import { Box, Heading, KsyosLogo, Text } from '@ksyos/design-system';
import { translateKey } from '../../../translate';
import {
    StyledContainer,
    StyledForm,
    StyledSelectEmploymentOption,
    StyledSelectEmploymentOptionText,
} from '../notLoggedIn/LoginStyledComponents';

interface ISelectEmploymentProps {
    employments: {
        id: string;
        organization?: {
            city?: string | null;
            name?: string;
        };
    }[];
    selectEmployment: (employmentId: string) => Promise<void>;
}

export function SelectEmployment(props: ISelectEmploymentProps) {
    return (
        <StyledContainer>
            <StyledForm submitOnEnter={true}>
                <Box textAlign="center">
                    <KsyosLogo />
                    <Heading
                        mt={4}
                        size="xlarge"
                        textAlign="center"
                    >
                        {translateKey('login.signIn')}
                    </Heading>
                </Box>
                <Box mt={16}>
                    <Heading size="large">{translateKey('organization.chooseOrganization')}</Heading>
                </Box>
                <Box
                    display="grid"
                    gap={6}
                    gridTemplateColumns={['1fr', '1fr 1fr']}
                    mt={8}
                >
                    {props.employments.map((employment) => (
                        <StyledSelectEmploymentOption
                            data-dd-action-name="select-organization"
                            key={employment.id}
                            onClick={async () => await props.selectEmployment(employment.id)}
                            tabIndex={0}
                            title={employment.organization?.name}
                        >
                            <StyledSelectEmploymentOptionText
                                color="default"
                                fontWeight="medium"
                                size="md"
                            >
                                {employment.organization?.name}
                            </StyledSelectEmploymentOptionText>
                            <Text
                                color="minimal"
                                mt={2}
                                size="sm"
                            >
                                {employment.organization?.city}
                            </Text>
                        </StyledSelectEmploymentOption>
                    ))}
                </Box>
            </StyledForm>
        </StyledContainer>
    );
}
